export default "__VITE_ASSET__DaeEQttO__"